class FunnelConfig extends BaseItemConfig {
    metric: KnockoutObservable<number>;
    field: KnockoutObservable<number>;
    descriptionField: KnockoutObservable<number>;
    fieldAutoGrouping: KnockoutObservable<AutoGroupingEnum>;
    topBottomType: KnockoutObservable<number>;
    topBottomValue: KnockoutObservable<number>;
    type: KnockoutObservable<FunnelTypeEnum>;
    legendPosition: KnockoutObservable<LegendPositionEnum>;
    labelVisibility: KnockoutObservable<boolean>;
    labelPosition: KnockoutObservable<FunnelLabelPositionEnum>;
    labelShowPercentage: KnockoutObservable<boolean>;

    decimalPlaces: KnockoutObservable<number>;
    format: KnockoutObservable<FieldFormatEnum>;
    unitFormat: KnockoutObservable<LabelFormatEnum>;
    
    constructor(data: any) {
        super(data);

        this.metric = ko.observable(data.metric);

        this.field = ko.observable(data.field);
        this.descriptionField = ko.observable(data.descriptionField);
        this.fieldAutoGrouping = ko.observable(data.fieldAutoGrouping);

        this.topBottomType = ko.observable(data.topBottomType);
        this.topBottomValue = ko.observable(data.topBottomValue);
        this.type = ko.observable(data.type);
        this.legendPosition = ko.observable(data.legendPosition);
        this.labelVisibility = ko.observable(data.labelVisibility);
        this.labelPosition = ko.observable(data.labelPosition);
        this.labelShowPercentage = ko.observable(data.labelShowPercentage);
        this.decimalPlaces = ko.observable(data.decimalPlaces);
        this.format = ko.observable(data.format);
        this.unitFormat = ko.observable(data.unitFormat);
    }

    get allowDetailTab(): boolean {
        return true;
    }

    override updateDrilldownListRemovingTemplateId(tabOrWidget: ITabOrWidget, callback: Function = null) {
        callback?.();
    }
}

enum FunnelTypeEnum {
    Funnel = 0,
    Pyramid = 1,
}

enum FunnelLabelPositionEnum {
    Columns = "columns",
    Inside = "inside",
    Outside = "outside"
}